<app-menu></app-menu>
<div class="wrapper" style="padding-top: 64px; padding-bottom: 128px">
  <div class="container-fluid">
    <router-outlet></router-outlet>
    <router-outlet name="side"></router-outlet>
  </div>
</div>
